import { Accordion, Typography } from '@remarkable/ark-web';

import { ButtonClicked } from 'src/ampli';
import { tracker } from 'src/analytics/tracker';
import type { FAQBlock } from 'src/constants/FAQ';

import { useLingui } from '@lingui/react/macro';
import { Divider } from './Divider';

interface FaqSectionProps {
  title?: string | false;
  sections: FAQBlock[];
  componentLocation?: string;
  className?: string;
  dataCy?: string;
}
export const FaqSection = (props: FaqSectionProps) => {
  const { t } = useLingui();
  const title = props.title ?? t`Frequently asked questions`;
  const dataCy = props.dataCy ?? 'faq-section';

  if (props.sections.length < 1) {
    return <></>;
  }

  return (
    <div className={props.className} data-cy={dataCy}>
      {!!title && (
        <>
          <Typography as="h2" variant="heading-subtle-xl" className="text-left">
            {title}
          </Typography>

          <Divider className="mt-32 mb-4 bg-divider" />
        </>
      )}
      <ul>
        {props.sections.map((section) => (
          <li key={section.id}>
            <Accordion
              data-cy={'faq-item ' + section.id}
              variant="secondary"
              onClick={() => {
                if (!props.componentLocation) return;

                tracker.trackEvent(
                  new ButtonClicked({
                    component_location: props.componentLocation,
                    action: 'toggle faq',
                    text: section.id,
                  })
                );
              }}
            >
              {/* We are not using typography components here by design as children are styled by Accordion. */}
              <h3>{section.title}</h3>
              {section.body}
            </Accordion>
          </li>
        ))}
      </ul>
    </div>
  );
};
